<cmx-loader *ngIf="loader"></cmx-loader>
<div class="login">
  <div class="login__container">
    <div class="login__logo">
      <img
        class="login__logo-img"
        src="https://www.cemexgo.com/cdn/logos/svg/cemex_mono_white.svg"
      />
    </div>
    <div class="login__panel">
      <h2>{{ 'form.loginForm.title' | translate }}</h2>
      <ng-container *ngIf="!error">
        <h3>{{ 'views.signin.welcome' | translate }}</h3>
      </ng-container>
      <ng-container *ngIf="error">
        <h3 class="login__panel--error">{{ error | translate }}</h3>
      </ng-container>
      <form [formGroup]="inputForm" (ngSubmit)="onLogin()">
        <div class="login__field">
          <input
            formControlName="email"
            class="login__input"
            type="text"
            [placeholder]="'form.loginForm.username.placeholder' | translate"
          />
          <div
            class="login__field-error"
            *ngIf="inputForm.controls.email.touched && !inputForm.controls.email.valid"
          >
            {{ 'form.loginForm.username.hint' | translate }}
          </div>
        </div>
        <div class="login__field">
          <input
            formControlName="pass"
            class="login__input"
            type="password"
            [placeholder]="'form.loginForm.password.placeholder' | translate"
          />
          <div
            class="login__field-error"
            *ngIf="inputForm.controls.pass.touched && !inputForm.controls.pass.valid"
          >
            {{ 'form.loginForm.password.hint' | translate }}
          </div>
        </div>
        <button class="login__submit" [disabled]="!inputForm.valid || loader" type="submit">
          {{ 'form.loginForm.submit' | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
